import React from 'react';
import { Message } from '@/types/chat';
import { cn } from '@/lib/utils';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

interface HelpMessageProps {
  message: Message;
}

export function HelpMessage({ message }: HelpMessageProps) {
  const isAssistant = message.role === 'assistant';

  return (
    <div className={cn(
      "flex gap-3 mb-4",
      !isAssistant && "flex-row-reverse"
    )}>
      <Avatar className="h-8 w-8">
        {isAssistant ? (
          <>
            <AvatarImage src="/placeholder.svg" alt="AI Assistant" />
            <AvatarFallback>AI</AvatarFallback>
          </>
        ) : (
          <>
            <AvatarImage src="/placeholder.svg" alt="User" />
            <AvatarFallback>U</AvatarFallback>
          </>
        )}
      </Avatar>
      <div className={cn(
        "rounded-lg px-4 py-2 max-w-[80%]",
        isAssistant ? "bg-secondary" : "bg-primary text-primary-foreground"
      )}>
        {message.content}
      </div>
    </div>
  );
}